import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { ChartOfAccountsSection } from '@/features/ledger/chart-of-accounts'

/**
 * The chart of accounts, as an addressable screen of its own.
 *
 * A read, at any width. Nothing here changes an account: `ledger.account.manage` is catalogued as a
 * countersigned operation and has no endpoint, which the screen says rather than implying through a
 * missing button.
 */
export function LedgerChartOfAccountsPage() {
  return (
    <>
      <Link
        to="/ledger"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All of the ledger
      </Link>

      <PageHeader
        title="Chart of accounts"
        description="One chart for the whole institution. A heading groups the accounts beneath it and refuses a posting; only the leaves take entries."
      />

      <ChartOfAccountsSection />
    </>
  )
}
